import { createContext, useContext, ReactNode, useState } from 'react';
import { api } from '../../services/services/api';

interface NegocioContextProviderProps {
  children: ReactNode;
}

interface NegocioContextProps {
  getNegocio(
    dataInicio: string,
    dataFim: string,
    credor?: string,
    appAcesso?: number,
  ): Promise<void>;
  negocio: DetalhamentoNegocioProps;
}

interface TipoNegocio {
  av: number;
  entrada: number;
  avEntrada: number;
  parcelas: number;
  total: number;
}
interface Recebimento {
  acordos: number;
  enviados: number;
  confEntrega: number;
  confCliente: number;
}
interface CanalEnvio {
  whatsapp: number;
  email: number;
  sms: number;
  download: number;
  codBarras: number;
}

interface Negocio {
  tipoNegocio: TipoNegocio;
  recebimento: Recebimento;
  canalEnvio: CanalEnvio;
}

interface DetalhamentoNegocioProps {
  negocio: Negocio;
  credores: number[];
  parcelas: { label: string; value: number }[];
}

const NegocioContext = createContext<NegocioContextProps>(
  {} as NegocioContextProps,
);

export const NegocioContextProvider: React.FC<NegocioContextProviderProps> = ({
  children,
}) => {
  const [negocio, setNegocio] = useState<DetalhamentoNegocioProps>(
    {} as DetalhamentoNegocioProps,
  );

  async function getNegocio(
    dataInicio: string,
    dataFim: string,
    credor?: string,
    appAcesso?: number,
  ) {
    await api
      .get('/detalhamento-negocio', {
        params: {
          dataInicio,
          dataFim,
          credor: credor === 'Todos' ? undefined : credor,
          appAcesso,
        },
      })
      .then(({ data }) => {
        setNegocio(data.negocio);
      });
  }

  return (
    <NegocioContext.Provider
      value={{
        getNegocio,
        negocio,
      }}
    >
      {children}
    </NegocioContext.Provider>
  );
};

export const useNegocioContext = () => useContext(NegocioContext);
